import { mq, sizes } from 'src/theme'
import styled from 'styled-components'

import Icon from '../Icon'

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  border: 1px solid ${({ theme }) => theme.colors.greyA5};
  padding: 5rem 1rem 1rem 1rem;

  @media ${mq(sizes.tablet)} {
    padding: 4rem;
  }
`

export const Text = styled.div`
  text-align: center;
  ${({ theme }) => theme.textStyles.text_16};
`

export const CloseButtonWrapper = styled.div`
  position: absolute;
  top: 1rem;
  right: 1rem;
`

export const CloseButton = styled(Icon)`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  border: 1px solid ${({ theme }) => theme.colors.greyCE};
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.pureWhite};
  cursor: pointer;
  & svg {
    width: 1.75rem;
    height: 1.75rem;
    color: ${({ theme }) => theme.colors.pureBlack};
  }
`
